import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const HorizontalTimelineForm = ({ sectionId, itemToEdit, onSuccess, onCancel }) => {
  const isEdit = Boolean(itemToEdit);

  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    content: '',
    item_order: 1,
    progress_percentage: 0
  });

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  // Se estiver editando, carrega os dados atuais para o form
  useEffect(() => {
    if (isEdit && itemToEdit) {
      setFormData({
        title: itemToEdit.title || '',
        content: itemToEdit.description || '',
        subtitle: '', 
        item_order: itemToEdit.item_order || 1,
        progress_percentage: itemToEdit.progress_percentage || 0
      });
    }
  }, [isEdit, itemToEdit]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files).slice(0, 5);
    setFiles(selectedFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!sectionId) return alert("Erro: ID da seção não encontrado.");
    
    setLoading(true);
    const data = new FormData();

    data.append('section_id', sectionId);
    data.append('title', formData.title);
    data.append('subtitle', formData.subtitle);
    data.append('content', formData.content);
    data.append('item_order', formData.item_order);
    data.append('progress_percentage', formData.progress_percentage);

    files.forEach(file => {
      data.append('carousel_images', file);
    });

    try {
      if (isEdit) {
        await api.put(`/admin/timeline-items/${itemToEdit.id}`, data);
        alert('Fase atualizada com sucesso!');
      } else {
        await api.post('/admin/timeline-items', data);
        alert('Nova fase inserida com sucesso!');
      }
      onSuccess();
    } catch (err) {
      console.error(err);
      alert('Erro ao salvar fase da obra.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="animate__animated animate__fadeIn">
      <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
        <h5 className="fw-bold text-primary mb-0">
          <i className={`bi ${isEdit ? 'bi-pencil-square' : 'bi-plus-circle'} me-2`}></i> 
          {isEdit ? 'Editar Fase' : 'Adicionar Nova Fase'}
        </h5>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={onCancel}>
          <i className="bi bi-arrow-left me-1"></i> Voltar para Lista
        </button>
      </div>
      
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-8 mb-3">
            <label className="form-label fw-bold small">TÍTULO DA FASE</label>
            <input type="text" name="title" className="form-control" value={formData.title} onChange={handleChange} required />
          </div>
          <div className="col-md-4 mb-3">
            <label className="form-label fw-bold small">ORDEM (FASE Nº)</label>
            <input type="number" name="item_order" className="form-control" value={formData.item_order} onChange={handleChange} min="1" required />
          </div>
        </div>

        {/* ... (O restante do formulário: SUBTÍTULO, DESCRIÇÃO, SLIDER e UPLOAD) ... */}
        <div className="mb-3">
          <label className="form-label fw-bold small">SUBTÍTULO / CHAMADA</label>
          <input type="text" name="subtitle" className="form-control" value={formData.subtitle} onChange={handleChange} placeholder="Ex: Início das obras estruturais." />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold small">DESCRIÇÃO BREVE</label>
          <textarea name="content" className="form-control" rows="3" value={formData.content} onChange={handleChange}></textarea>
        </div>

        <div className="mb-4 p-3 bg-light rounded border">
          <label className="form-label fw-bold small d-block mb-3">
            PERCENTUAL DE CONCLUSÃO: <span className="text-primary">{formData.progress_percentage}%</span>
          </label>
          <input type="range" className="form-range" name="progress_percentage" min="0" max="100" value={formData.progress_percentage} onChange={handleChange} />
          <div className="d-flex justify-content-between small text-muted">
            <span>0%</span><span>50%</span><span>100%</span>
          </div>
        </div>

        <div className="mb-4">
          <label className="form-label fw-bold small">FOTOS DO CARROSSEL (Máx. 5)</label>
          <input type="file" className="form-control" multiple accept="image/*" onChange={handleFileChange} />
          {isEdit && <div className="form-text text-warning"><i className="bi bi-exclamation-triangle"></i> Atenção: Enviar novas fotos substituirá todas as fotos atuais desta fase.</div>}
        </div>

        <div className="d-flex gap-2">
          <button type="submit" className="btn btn-primary px-5 fw-bold" disabled={loading}>
            {loading ? 'Processando...' : 'SALVAR FASE'}
          </button>
          <button type="button" className="btn btn-outline-secondary px-4" onClick={onCancel}>CANCELAR</button>
        </div>
      </form>
    </div>
  );
};

export default HorizontalTimelineForm;